<app-filter-card
  i18n-heading
  heading="Meldungsfilter"
  testId="blog-filter"
  [canReset]="isFiltered"
  (reset)="resetFilter()"
>
  <app-date-range-filter
    testId="blog-filter-date"
    i18n-fromLabel
    fromLabel="Gültig von"
    i18n-toLabel
    toLabel="Gültig bis"
    [(from)]="filter.validFrom"
    [(to)]="filter.validTo"
    (rangeChange)="searchThis()"
  ></app-date-range-filter>
</app-filter-card>
